/* eslint-disable import/prefer-default-export */
import { useHistory } from 'react-router-dom';

export const useIsReviewClassActive = () => {
  const history = useHistory();
  const path = history.location.pathname;
  const isReviewClassActive = path.includes('assessment');
  return isReviewClassActive;
};
